// src/router/componentMap.js
// 大屏
import ScreenView from  '../views/ScreenView.vue'
// 基础组件

import DefaultView from '../views/DefaultView.vue'

// 设备管理相关
import DeviceView from '../views/DeviceView.vue'
import PesticideView from '../views/PesticideView.vue'
import SampleView from '../views/SampleView.vue'
import CabinetView from '../views/CabinetView.vue'
import DetectionView from '../views/DetectionView.vue'
import MorningCheckView from '../views/MorningCheck.vue'

// 排菜与采购
import PlanningView from '../views/PlanningView.vue'
import ProcurementView from '../views/ProcurementView.vue'

// 功能间与首页
import FunctionView from '../views/FunctionView.vue'
import IndexView from '../views/IndexView.vue'

// 公告与轮播
import OrganizationView from '../views/OrganizationView.vue'
import WarehouseView from '../views/WarehouseView.vue'
import WarehouseView1 from '../views/WarehouseView1.vue'
import WarehouseView2 from '../views/WarehouseView2.vue'

// 烹饪与管理
import CookingView from '../views/CookingView.vue'
import ManageView from '../views/ManageView.vue'
// 生产任务
import ProductionManagementView from '../views/ProductionManagementView'

// 物料与订单
import SupplierView from '../views/SupplierView.vue'
import OrderView from '../views/OrderView.vue'
import RequirementView from '../views/RequirementView.vue'
import ApprecordView from '../views/ApprecordView.vue'
import QuotationView from '../views/QuotationView.vue'

// 菜品相关
import DishView from '../views/DishView.vue'
import CoverView from '../views/CoverView.vue'
import MenuView from '../views/MenuView.vue'
import MenuView1 from '../views/MenuView1.vue'
// 培训与案例
import AnalysisView from '../views/AnalysisView.vue'
import AppView from '../views/AppView.vue'
import PromotionView from '../views/PromotionView.vue'

// 人员与客户
import PersonnelView from '../views/PersonnelView.vue'
import CustomerView from '../views/CustomerView.vue'

// 仓库与物料
import TerminalView from '../views/TerminalView.vue'
import ProductView from '../views/ProductView.vue'
import RecordView from '../views/RecordView.vue'
import CustomerOrderView from '../views/CustomerOrder.vue'
import IngredientsView from '../views/IngredientsView.vue'
import StorageLocationView from '../views/StorageLocationView.vue'
// 功能间设备与角色
import FunctionalDataView from '../views/FunctionalData.vue'
import RoleView from '../views/RoleView.vue'
// 交互屏
import JiaoHuPingView from '../views/JiaoHuPingView'
import RecordsView from '../views/RecordsView'
import RechargView from '../views/RechargView'
import VegetableView from '../views/VegetableView'
import StaffView from '../views/StaffView'
// 行为分析
import XingWeiView from '../views/XingWeiView'
// 出库计划
import OutboundPlanView from '../views/OutboundPlanView'
// 需求物料
import RequiredMaterialsView from '../views/RequiredMaterialsView'

// 维保记录
import MaintenanceView from '../views/MaintenanceView'
// 设备告警
import DeviceAlarmView from '../views/DeviceAlarmView'
//  设备告警记录
import AlarmView from '../views/AlarmView'
// 设备列表
import DeviceListView from '../views/DeviceListView'
// 菜单
import SyetemMenuView from '../views/SyetemMenuView'
import AccessoriesView from '../views/AccessoriesView'
// 文件管理
import FilesView from '../views/FilesView'
// 套餐
// 监控
import MonitorView from '../views/MonitorView'
import ComboView from '../views/ComboView'
import DishEvaluate from '../views/DishEvaluate'
// 采购预算
import BudGet from '../views/BudGet'
export default {
  'BudGet':BudGet,
  'MonitorView':MonitorView,
  'FilesView':FilesView,
'ComboView':ComboView,
'MaintenanceView':MaintenanceView,
'DeviceAlarmView':DeviceAlarmView,

"DeviceListView":DeviceListView,

"SyetemMenuView":SyetemMenuView,

// 设备配件
"AccessoriesView":AccessoriesView,


'ScreenView':ScreenView,
  'Default': DefaultView,

  // 设备管理相关
  'DeviceView': DeviceView,
  'PesticideView': PesticideView,
  'SampleView': SampleView,
  'CabinetView': CabinetView,
  'DetectionView': DetectionView,
  'MorningCheckView': MorningCheckView,

  // 排菜与采购
  'PlanningView': PlanningView,
  'ProcurementView': ProcurementView,

  // 功能间与首页
  'FunctionView': FunctionView,
  'IndexView': IndexView,

  // 公告与轮播
  'OrganizationView': OrganizationView,
  'WarehouseView': WarehouseView,
  'WarehouseView1': WarehouseView1,
  'WarehouseView2': WarehouseView2,

  // 烹饪与管理
  'CookingView': CookingView,
  'ManageView': ManageView,
'ProductionManagementView':ProductionManagementView,
  // 物料与订单
  'SupplierView': SupplierView,
  'OrderView': OrderView,
  'RequirementView': RequirementView,
  'ApprecordView': ApprecordView,
  'QuotationView': QuotationView,
  // 需求物料
  
'RequiredMaterialsView':RequiredMaterialsView,
  // 菜品相关
  'DishView': DishView,
  'CoverView': CoverView,
  'MenuView': MenuView,

  // 培训与案例
  'AnalysisView': AnalysisView,
  'AppView': AppView,
  'PromotionView': PromotionView,

  // 人员与客户
  'PersonnelView': PersonnelView,
  'CustomerView': CustomerView,

  // 仓库与物料
  'TerminalView': TerminalView,
  'ProductView': ProductView,
  'RecordView': RecordView,
  'CustomerOrderView': CustomerOrderView,
  'IngredientsView': IngredientsView,
'StorageLocationView':StorageLocationView,
'OutboundPlanView':OutboundPlanView,
  // 功能间设备与角色
  'FunctionalDataView': FunctionalDataView,
  'RoleView': RoleView,
  // 交互屏
  'JiaoHuPingView':JiaoHuPingView,
  'MenuView1':MenuView1,
  'RecordsView':RecordsView,
  'RechargView':RechargView,
  'VegetableView':VegetableView,
  'StaffView':StaffView,
'AlarmView':AlarmView,
// 行为分析
'XingWeiView':XingWeiView,
// 菜品评价
'DishEvaluate':DishEvaluate
}